export default "__VITE_ASSET__c4bd907b__"